import { createCrud } from '../../CRUD';
import { TMessage } from './types';

export const messageBaseModel = createCrud<TMessage>('messages', 'Message');
